import React from 'react';
import { useCounter } from '../useCounter';

export const StartCounter = ({ expired, countFrom }) => {
  const { count } = useCounter({ expired, countFrom });

  return (
    <div className="ct-record-counter-overlay">
      <span className="ct-record-counter-overlay__bg"></span>
      <div className="ct-record-counter">
        <svg className="ct-record-counter__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <g className="ct-record-counter__circle">
            <circle className="ct-record-counter__path-elapsed" cx="50" cy="50" r="45"></circle>
          </g>
        </svg>
        <span className="ct-record-counter__label">{count}</span>
      </div>
    </div>
  );
};
